import React from 'react'
import { TmrItem } from 'stylewhere/api'
import { Skeleton } from '@chakra-ui/react'
import { ItemRow, EmptyListMessage, Spacer } from 'stylewhere/components'
import { T, __ } from 'stylewhere/i18n'

interface Props {
  items: TmrItem[]
  emptyMessage?: string | JSX.Element
  style?: React.CSSProperties
  loading?: boolean
  onInfoRowPress?: (tag: TmrItem) => void
  onDeleteRowCallback?: (item: TmrItem) => void
}

export function ItemList({
  items,
  emptyMessage = <span style={{ whiteSpace: 'break-spaces' }}>{__(T.messages.press_start_to_read)}</span>,
  style,
  loading = false,
  onInfoRowPress,
  onDeleteRowCallback,
}: Props) {
  if (!items) return null

  return (
    <Skeleton
      isLoaded={!loading}
      style={items?.length !== 0 ? style : { display: 'flex', flex: 1, justifyContent: 'center' }}
    >
      {items.length > 0 &&
        items.map((item, index) => (
          <>
            <ItemRow
              key={item.id}
              id={index}
              item={item}
              onInfoPress={item.product && item.identifiers.length > 0 ? onInfoRowPress : undefined}
              onDeleteCallback={onDeleteRowCallback}
            />
            <Spacer />
          </>
        ))}
      {(!items || items.length === 0) && <EmptyListMessage center>{emptyMessage}</EmptyListMessage>}
    </Skeleton>
  )
}
